"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.AttributeType = {
    NONE: 'NONE',
    LONG: 'LONG',
    DOUBLE: 'DOUBLE',
    STRING: 'STRING',
    DATETIME: 'DATETIME',
    INSTANT: 'INSTANT',
    TIME: 'TIME',
    TIMESPAN: 'TIMESPAN',
    FOREIGN_KEY: 'FOREIGN_KEY',
    MULTI_FOREIGN_KEY: 'MULTI_FOREIGN_KEY',
    USER_SIGNATURE: 'USER_SIGNATURE',
    PARAMETERS: 'PARAMETERS',
    MULTI_VALUE: 'MULTI_VALUE'
};
//# sourceMappingURL=attribute-type.js.map